import type { ReactNode } from 'react'
import {
  BookOpen,
  CircleUserRound,
  KeyRound,
  Layers,
  Settings,
  Video,
} from 'lucide-react'
import { LearnerLegacyRoute } from './LearnerLegacyRoute'
import {
  learnerMainMenuRouteDefinitions,
  learnerRouteDefinitions,
} from './learner-route-definitions'
import type { LearnerRouteDefinition, LearnerRouteId } from './learner-route-types'

export interface LearnerRouteRegistryEntry extends LearnerRouteDefinition {
  readonly element: ReactNode
}

const learnerRouteIconMap: Partial<Record<LearnerRouteId, ReactNode>> = {
  'activation-key': <KeyRound aria-hidden="true" size={20} strokeWidth={2.4} />,
  flashcards: <Layers aria-hidden="true" size={20} strokeWidth={2.4} />,
  learning: <BookOpen aria-hidden="true" size={20} strokeWidth={2.4} />,
  profile: <CircleUserRound aria-hidden="true" size={20} strokeWidth={2.4} />,
  settings: <Settings aria-hidden="true" size={20} strokeWidth={2.4} />,
  'short-videos': <Video aria-hidden="true" size={20} strokeWidth={2.4} />,
}

function attachRouteIcon(route: LearnerRouteDefinition): LearnerRouteDefinition {
  return {
    ...route,
    navIcon: route.navIcon ?? learnerRouteIconMap[route.id],
  }
}

export const learnerRoutes = learnerRouteDefinitions.map((route) => {
  const routeWithIcon = attachRouteIcon(route)

  return {
    ...routeWithIcon,
    element: (
      <LearnerLegacyRoute
        opensActivationKey={route.opensActivationKey}
        screenId={route.legacyScreen}
      />
    ),
  }
}) satisfies readonly LearnerRouteRegistryEntry[]

export const learnerMainMenuRoutes = learnerMainMenuRouteDefinitions.map(attachRouteIcon)
